module.exports = __webpack_public_path__ + "static/media/sample-club-with-player-count.2b207734.png";